import { useState } from "react"
import { Link } from "react-router-dom"
import BCButom from "../Tools/BCButom"
import './styles/styles.css'
const Sidbar = ({children}) => {
    const [statusSidbar, setStatusSidbar] = useState(false)
    const [statusSidbarButtom, setStatusSidbarButtom] = useState(false)
    const [styleSidbar, setStyleSidbar] = useState({});
    const checkScrollTop = (event) => {
        if(window.pageYOffset >=80 ){
            setStyleSidbar({position: "fixed", top: "0"}); 
            setStatusSidbar(true)
            if((window.screen.height-100) <= window.pageYOffset ){
                setStyleSidbar({position: "fixed", bottom: "555px"}); 
                setStatusSidbarButtom(true)
            }else{
                
                setStatusSidbarButtom(false)
                // setStyleSidbar({position: "fixed", top: "0"});
            }
        }else{
            setStatusSidbar(false)
            setStyleSidbar({position: ""});
        }        
    }
    window.addEventListener('scroll', (event) => checkScrollTop(event))
    return (
       <>
            <div className='sildBarRight' style={styleSidbar}>
                <div style={{borderBottom: "#fff dashed 1px", marginBottom: "20px", paddingBottom: "10px"}}><h5>آموزشی </h5></div>
                <div className='slireRightItems'><Link className="linksSidbar" to={`/empty`}><h5>راهنمای بیماران </h5></Link></div>
                <div className='slireRightItems'><Link className="linksSidbar" to={`/empty`}><h5>آموزش به بیماران </h5></Link></div>
                <div className='slireRightItems'><Link className="linksSidbar" to={`/empty`}><h5>تالار گفتگوی همکاران </h5></Link></div>
                <div className='slireRightItems'><Link className="linksSidbar" to={`/empty`}><h5>تالار گفتگوی دانشجویان </h5></Link></div>
                <div className='slireRightItems' style={{visibility: "hidden"}}><Link className="linksSidbar" to={`/empty`}><h5>تالار گفتگوی دانشجویان </h5></Link></div>
                <img src='./image/Doctor/logo gold.png' className='imageLogo'  style={{marginTop: "0px"}}/>
            </div>
            <div className='sildBarLeft' style={styleSidbar}>
                <div style={{borderBottom: "#fff dashed 1px", marginBottom: "20px", paddingBottom: "10px"}}><h5>کلینیکهای فعال </h5></div>
                <div className='slireLeftItems'><Link className="linksSidbar" to={`/empty`}><h5>کلینیک واریس و لیزر</h5></Link></div>
                <div className='slireLeftItems'><Link className="linksSidbar" to={`/empty`}><h5>  کلینیک زخم و پای دیابتی</h5></Link></div>
                <div className='slireLeftItems'><Link className="linksSidbar" to={`/empty`}><h5>  کلینیک پایش سلامت عروقی</h5></Link></div>
                <div className='slireLeftItems'><Link className="linksSidbar" to={`/empty`}><h5> کلینیک لنف ادم(لنفوتراپی)</h5></Link></div>
                <div className='slireLeftItems'><Link className="linksSidbar" to={`/empty`}><h5>   کلینیک چکاپ بیماران دیابتی</h5></Link></div>
                <img src='./image/Doctor/logo gold.png' className='imageLogo'  style={{marginTop: "0px"}}/>
            </div>

            {children}
          </>
    )
}
export default Sidbar;